import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    
    
}
const mutations={
   
    setAgentUserPassword(state,value){
        

       
        post(urls.admin.agent_password.index,value).then((result)=>{
          
          
          state.result=result
         
       
        
       
           
        });
        
    },
   
 

     
  
  
    
 

}
const  actions={

    
   setAgentUserPasswordAction(context,value){
       
        context.commit("setAgentUserPassword",value)
       
    },
  
  
    

}

export default {state,mutations,actions}